<template>
  <file-list
    v-model="attachments"
    :create-file="attachmentCreate"
    :disabled="disabled"
    :multiple="false"
    :name-folder="documentUuid"
    :remove-file="file => attachmentDelete(Number(file.id))"></file-list>
</template>

<script setup lang="ts">
import FileList from '@/components/FileList.vue'
import { useDocument } from '../document'

defineOptions({
  name: 'Attachment',
})

const {
  documentUuid,
  attachments,
  disabled,
  attachmentCreate,
  attachmentDelete,
} = useDocument()
</script>
